export const viewModeSwitcherTheme = {
  bg: 'palette.surface.4',
  borderColor: 'palette.tertiary.20',
  borderRadius: '5px',
  borderWidth: '1px',
  modeItem: {
    active: {
      bg: 'palette.primary.20',
      borderRadius: '5px',
      icon: 'palette.primary.99',
    },
    base: {
      bg: 'palette.transparent',
      borderRadius: '5px',
      icon: 'palette.tertiary.50',
    },
    hover: {
      bg: 'palette.tertiary.5',
      borderRadius: '5px',
      icon: 'palette.tertiary.70',
    },
    pressed: {
      bg: 'palette.tertiary.10',
      borderRadius: '5px',
      icon: 'palette.tertiary.80',
    },
  },
};
